import { Component, DestroyRef, input, OnInit, inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Lender } from '@app/core/stingray-api/models';
import { finalize, map } from 'rxjs/operators';
import { requireMatch } from '@app/validators/autocomplete-validator';
import { LenderAutoCompleteService } from './lender-autocomplete.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatListItem } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';


@Component({
    selector: 'unite-lender-autocomplete',
    templateUrl: './lender-autocomplete.component.html',
    styleUrls: ['./lender-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatProgressSpinner, MatSuffix, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule, MatListItem]
})
export class LenderAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();
  appearance = input('outline');
  floatLabel = 'auto';
  isMatListItem = input(false);

  lenders: Lender[] = [];
  lendersFiltered: Lender[];

  isLoadingLenders = false;

  constructor(
    private lenderAutoCompleteService: LenderAutoCompleteService) { }

  ngOnInit() {
    if (this.floatLabel !== 'outline') {
      this.floatLabel = 'always';
    }

    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.isLoadingLenders = true;
    this.lenderAutoCompleteService.getLenders().pipe(
      finalize(() => {
        this.isLoadingLenders = false;
      })
    ).subscribe((customers: Lender[]) => {
      this.lenders = customers;
      this.lendersFiltered = customers;
    });

    this.control().valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
      map((value: string | Lender) => {
        if (this.isLender(value)) {
          return this.filterLender(value.name);
        } else {
          return this.filterLender(value || '');
        }
      })
    ).subscribe((lenders: Lender[]) => {
      this.lendersFiltered = lenders;
    });
  }

  displayWithLender(lender: Lender): string {
    if (lender != null) {
      return lender.name;
    } else {
      return '';
    }
  }

  filterLender(value: string): Lender[] {
    const filterValue = value.toLowerCase();
    return this.lenders.filter((lender: Lender) => {
      return this.displayWithLender(lender).toLowerCase().includes(filterValue) ||
      String(lender.number).includes(filterValue);
    });
  }

  isLender(value: any | Lender): value is Lender {
    return value != null && (<Lender>value).number !== undefined;
  }
}
